import { render, staticRenderFns } from "./TextResource.vue?vue&type=template&id=f95fb650&scoped=true&"
import script from "./TextResource.vue?vue&type=script&lang=js&"
export * from "./TextResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95fb650",
  null
  
)

export default component.exports